import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {GridList, GridTile} from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import Paper from 'material-ui/Paper';
import withActionOnMount from './shared/ActionOnMount';
import { fetchServices } from '../redux/actions';
import Snackbar from 'material-ui/Snackbar';

import Pay from './Paypal';
import About from './About';
import Locations from './Locations';
import MainActions from './MainActions';
import ContactInfo from './ContactInfo';


const styles = 
{
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around'
  },
  gridList: {
    width: "800px",
    height: "auto",
    overflowY: 'auto',
    marginBottom: "5%"
  },
};

const ServiceGridList = ({ services=[] }) => 
(
  <div style={styles.root}>
        <GridList
        cols={3}
        cellHeight={200}
        padding={0}
        style={styles.gridList}
        >
        {services.map(item => (
            <GridTile
            key={item._id}
            title={item.name}
            titleStyle={{marginLeft: "20%"}}
            actionPosition="left"
            titlePosition="top"
            titleBackground="linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
            cols={1}
            rows={1}
            >
                <img src={item.imgPath} />
            </GridTile>
        ))}
        </GridList>
  </div>
);

const Home = ({refServices=[], maintanenceServices=[], landscapingServices=[], fertilizationServices=[], pressureWashingServices=[]}) => 
(
    <div className="content" >
        <Pay />
        <About/>
        <Row>
            <Col xs={12}>
                <Row center="xs">
                    <h3>Contact Us Today For A Quote!</h3>
                </Row>
            </Col>
        </Row>
        <ContactInfo />
        <section style={{backgroundColor: "#f3f2f0"}} >

                <Row>
                    {/* <Col xs={12}>
                        <Row center="xs">
                            <h2>Primary Services</h2>
                        </Row>
                    </Col> */}
                    <Col xs={12}>
                        <Row center="xs">
                            <h4>Lawncare Maintance</h4>
                        </Row>
                    </Col>
                </Row>
                <ServiceGridList services={maintanenceServices} />
 
        </section>
        <section style={{backgroundColor: "white"}}>
            <Row>
                <Col xs={12}>
                    <Row center="xs">
                        <h4>Landscaping</h4>
                    </Row>
                </Col>
            </Row>
            <ServiceGridList services={landscapingServices} />
        </section>
        <section style={{backgroundColor: "#f3f2f0"}} >

                <Row>
                    <Col xs={12}>
                        <Row center="xs">
                            <h4>Fertilization</h4>
                        </Row>
                    </Col>
                </Row>
                <div style={styles.root}>
                    <GridList
                    cols={2}
                    cellHeight={200}
                    padding={1}
                    style={styles.gridList}
                    >
                    {fertilizationServices.map(item => (
                        <GridTile
                        key={item._id}
                        title={item.name}
                        actionIcon={<IconButton><StarBorder color="white" /></IconButton>}
                        actionPosition="left"
                        titlePosition="top"
                        titleBackground="linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
                        cols={1}
                        rows={1}
                        >
                        <img src={item.imgPath} />
                        </GridTile>
                    ))}
                    </GridList>
                </div>
        
        </section>
        <section style={{backgroundColor: "white"}}>
            <Row>
                <Col xs={12}>
                    <Row center="xs">
                        <h4>Pressure Washing</h4>
                    </Row>
                </Col>
            </Row>
            <ServiceGridList services={pressureWashingServices} />
        </section>

        { refServices.length > 0 && 
            <div>
                <Row>
                    <Col xs={12}>
                        <Row center="xs">
                            <h2>Refferal Services</h2>
                        </Row>
                    </Col>
                </Row>
                <ServiceGridList services={refServices} />
            </div>
        }
        <Locations />
    </div>        
);

const mapDispatchToProps = dispatch =>
({
    populate: () => dispatch(fetchServices())
});


const mapStateToProps = ({services}) => 
({
    maintanenceServices: services.maintanenceServices,
    landscapingServices: services.landscapingServices,
    fertilizationServices: services.fertilizationServices,
    pressureWashingServices: services.pressureWashingServices
});

const actionsOnMount = ({ populate }) => populate();

export default withActionOnMount(Home, actionsOnMount, mapStateToProps, mapDispatchToProps);


// WEBPACK FOOTER //
// ./src/components/Home.js